export default "__VITE_ASSET__944189ef__"